const aiChannels = [
  { label: 'WhatsApp', value: 'whatsapp' },
  { label: 'Phone call', value: 'call' },
];

const aiOutcomes = [
  { label: 'Positive Closure', value: 'positive' },
  { label: 'Negative Closure', value: 'negative' },
  { label: 'Schedule appointment', value: 'appointment' },
];

const aiRoutingModes = [
  { label: 'Autonomous', value: 'autonomous' },
  { label: 'Pre-qualify', value: 'prequalify' },
];

// The models allowed for the conversation engine. The list is deliberately
// closed: a hand-typed model OpenRouter does not know would fail every
// conversation, and the failure would show only at runtime.
//
// Haiku 4.5 was on this list for a day and came off on 28 September. It costs
// about a quarter of Sonnet per turn, and on a short qualification that looked
// like enough. It is not enough where the ORDER of what is said is the
// requirement: asked three times whether to name a financial product to
// somebody whose income it had not yet established, it named it once — and
// live, that day, it named it. Asked to write the sentence that turns a person
// down, it promised a call back nobody would make in three replies out of
// five, the explicit ban on promises included.
//
// Moved from Sonnet 5 to Sonnet 5.5 on 1 October. Same price per token, the
// same million of context, and tools and tool_choice both still supported, so
// nothing in the engine had to move with it. The engine does not send
// temperature, which 5.5 accepts and 5 did not — worth knowing only so that
// nobody reads that difference as a behaviour change.
//
// Because the list is closed, a stored agent left on the old value fails this
// file's validation the next time somebody opens the form: migrating the
// `aiAgents` documents belongs with this change, not after it.
//
// The list is closed and single on purpose. If Sonnet 5.5 is ever unavailable
// there is no configured spare, which is one line to add and worth knowing
// before it happens rather than during.
const aiModels = [
  { label: 'Claude Sonnet 5.5', value: 'anthropic/claude-sonnet-5.5' },
];

export { aiChannels, aiOutcomes, aiRoutingModes, aiModels };
